<template>
  <el-row>
    <!--类型值：{{sys_code_value}}-->

    <el-select v-model="sys_code_value"
               :placeholder="sys_code_placeholder"
               size="mini"
               :style="sys_code_style"
               :multiple="sys_code_multiple"
               @change="change"
               :disabled="disabled_text"
               :filterable="filterable"
               remote
               :remote-method="remoteMethod"
    >
      <el-option
        v-if="!sys_code_multiple && sys_code_has_all"
        :label="default_label_name"
        value=""
      >

      </el-option>

      <el-option
        v-for="item in options"
        :key="item.label_id"
        :label="item.label_name"
        :value="item.label_id"
        :disabled="item.disabled"
      >
        <span style="float: left">{{ item.label_name }}</span>
        <span v-show="item.is_created == true" style="float: right; color: #8492a6; font-size: 13px">（新标签）</span>
      </el-option>
    </el-select>
  </el-row>
</template>
<script type="text/javascript">
    import * as API from "@/api/index.js"

    export default {
      components:{

      },
        props: {
            sys_code_style: {//选择器样式
                type: Object,
                default: function () {
                    return {"width": "100%"}
                }
            },
            label_group_search: {//类型
                type: String,
                default: ""
            },
            sys_code_multiple: {//是否多选
                type: Boolean,
                default: false
            },
            sys_code_has_all: {//是否有全部选项
                type: Boolean,
                default: true
            },
            excude_list: {//排除列表，编码以逗号分割
                type: String,
                default: ""
            },
            disabled_list: {//禁用列表，编码以逗号分割
                type: String,
                default: ""
            },
            sys_code_placeholder: {//提示文字
                type: String,
                default: "请选择"

            },
            disabled_text: {
                type: Boolean,
                default: false
            },
            // default_value:{
            // 	type:String,
            // 	default:""
            // },
            default_label_name: {
                type: String,
                default: "全部"
            },
            data_value: {
                type: Array,
                default: function () {
                    return []
                }
            },

          filterable:{
            type:Boolean,
            default:true,
          },

        },
        data() {


            let value = this.getValue()


            return {
                options: [],//下拉数据
                option_dict: {},//下拉数据字典
                sys_code_value: value,
              label_name_list:[],
              init_label_options:[],
              init_options_dict:[],
              first: true,

            }

        },
        model: {
            prop: 'data_value',
            event: 'data_value_change'
        },
        watch: {
            data_value(new_value, old_value) {
                this.sys_code_value = this.getValue(new_value)
            },

        },
        computed: {

            excude: function () {
                var data = {}
                this.excude_list.split(",").map((item) => {
                    data[item] = true
                })
                return data
            },
            disabled: function () {
                var data = {}
                this.disabled_list.split(",").map((item) => {
                    data[item] = true
                })
                return data
            },


        },
        mounted() {
            this.getData()
        },
        methods: {

        remoteMethod(query){
          this.getData(query)
        },

            getValue() {
                var value = []
                if (this.sys_code_multiple) {
                    value = this.data_value
                } else {
                    var value = ''
                    value = this.data_value[0]
                }
                return value;
            },
            //选中事件
            change(value) {

                var selected_item = undefined
                var data_value = []
                var new_labels = []

                if (this.sys_code_multiple) {//多选
                    selected_item = []

                    value.map((item) => {
                      var label_dict = this.init_options_dict[item]

                      if(!label_dict || label_dict.is_created){
                          new_labels.push(item)
                          label_dict = {}
                          label_dict.label_id = item
                          label_dict.label_name = item
                          label_dict.is_created = true
                      }
                      selected_item.push(label_dict)

                    })
                    data_value = value
                } else {//单选
                    // var data_value = ''
                    selected_item = this.init_options_dict[value]
                    if(!selected_item || selected_item.is_created){
                      new_labels.push(value)
                      selected_item = {}
                      selected_item.label_id = value
                      selected_item.label_name = value
                      selected_item.is_created = true
                    }
                    data_value.push(value)
                }
                this.$emit("sys_code_change", value, selected_item, new_labels)
                this.$emit('data_value_change', data_value);
            },
            //获取数据
            async getData(query) {

                var query_data = {}
                query_data.label_group_search = this.label_group_search
                if(query){
                  query_data.label_name_search = query
                }

                // var label_group_name = {'label_group_search': this.label_group_search}
                const response = await API.GET('/omnis/system/label_manage/', query_data)
                if (response && response.data) {
                    var arr = response.data.data
                    //清空数据
                    var remove_list = []
                    arr.map((item) => {
                        //添加删除列表
                        if (this.excude.hasOwnProperty(item.label_id)) {
                            remove_list.push(item)
                        }
                        //禁用
                        if (this.disabled.hasOwnProperty(item.label_id)) {
                            item["disabled"] = true
                        }
                        //添加字典
                        this.option_dict[item.label_id] = item

                      this.label_name_list.push(item.label_name)
                    })
                    //删除
                    remove_list.map((item) => {
                        arr.remove(item)
                    })
                    this.options = arr

                  if(this.first){
                    this.init_label_options = arr
                    this.init_options_dict = this.option_dict
                    this.first = false
                  }


                }


            },

        }
    }
</script>



// WEBPACK FOOTER //
// label_sys_select.vue?3f301033